import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { Translate } from "components/common/Translate/Translate";
import { PerfectQualityIcon } from "components/common/Icons/PerfectQualityIcon";
import { LightningFastIcon } from "components/common/Icons/LightningFastIcon";
import { EasyToUseIcon } from "components/common/Icons/EasyToUseIcon";

export const MemeGeneratorContent = () => {
    return (
        <div className="mx-auto my-20" style={{ maxWidth: "840px" }}>
            <ContentParent>
                <ContentItem
                    title={<Translate keyName="content-meme-generator-title" />}
                    description={<Translate keyName="content-meme-generator-sub-title" />}
                    icon={<PerfectQualityIcon />}
                />
                <ContentItem
                    title={<Translate keyName="content-text-generator-title" />}
                    description={<Translate keyName="content-text-generator-sub-title" />}
                    icon={<LightningFastIcon />}
                />
                <ContentItem
                    title={<Translate keyName="content-host-generator-title" />}
                    description={<Translate keyName="content-host-generator-sub-title" />}
                    icon={<EasyToUseIcon />}
                />
            </ContentParent>
        </div>
    );
};
